export enum SMSProviders {
  amazon = 'amazon',
  twilio = 'twilio',
  sinch = 'sinch',
  telnyx = 'telnyx',
  smscenter = 'smscenter',
  alibaba = 'alibaba'
}

export type SMSProviderFields = {
  [key: string]: string | boolean | undefined;
  // AWS Access Key Secret or Twilio Auth Token or Sinch Api Token or Telnyx Api Key
  app_secret: string;
  // AWS Access Key ID or Twilio Account Sid or Sinch Service Plan ID
  app_id?: string;
  // Region parameter for AWS provider
  aws_region?: string;
  // Sender phone number for Twilio, Sinch or Telnyx
  phone_number?: string;
  // Sender ID from AWS, Twilio or Telnyx
  sender_id?: string;
  is_enabled?: boolean;
  name: string;
};

export type SMSProviderValues = SMSProviderFields;

export type PreparedProviderValues = Record<SMSProviders, SMSProviderFields> & {
  [key: string]: SMSProviderFields;
};

export type SelectedProviders = Record<SMSProviders, boolean>;

export type EmailProvider = {
  custom_email: string;
  from_email_name: string;
  provider_settings: EmailProviderFields;
};

export type EmailProviderFields = {
  [key: string]: string | number | undefined;
  // SendGrid API Key
  sendgrid_api_key: string;
  // Custom provider host
  host?: string;
  // Custom provider port
  port?: number;
  // Custom provider username
  username?: string;
  // Custom provider password
  password?: string;
};
